import type { ProjectOnboarding, ProjectTask, TaskGroup, TimberProject } from '../types';
import { isEarlyFunnelProjectPhase } from '../types';
import { onboardingItemToProjectTask } from './onboardingTaskBridge';
import { taskInvolvesUser } from './projectTaskUsers';

/** Same task universe as Project Hub all-projects roll-up + work queue modal. */
export function mergeTasksForWorkQueueEligibility(
  p: TimberProject,
  projectTasks: ProjectTask[],
  taskGroups: TaskGroup[],
  projectOnboardings: ProjectOnboarding[],
): ProjectTask[] {
  if (!p.id) return [];
  const pid = p.id;
  const groupsForProject = taskGroups.filter((g) => g.projectId === pid);
  const onboardingDoc = projectOnboardings.find((ob) => ob.projectId === pid);
  const onboardingMirrored =
    onboardingDoc?.items?.length
      ? onboardingDoc.items.map((it) => onboardingItemToProjectTask(it, pid, groupsForProject))
      : [];
  const firestoreForProject = projectTasks.filter((t) => t.projectId === pid);
  return [...onboardingMirrored, ...firestoreForProject];
}

export function projectHasActiveWorkQueueInvolvement(
  p: TimberProject,
  userId: string,
  projectTasks: ProjectTask[],
  taskGroups: TaskGroup[],
  projectOnboardings: ProjectOnboarding[],
): boolean {
  if (!userId || !p.id || p.status === 'completed') return false;
  return activeWorkQueueTasksInvolvingUser(p, userId, projectTasks, taskGroups, projectOnboardings).length > 0;
}

/** Active tasks that count toward work-queue involvement for `userId` (same filter as hub eligibility). */
export function activeWorkQueueTasksInvolvingUser(
  p: TimberProject,
  userId: string,
  projectTasks: ProjectTask[],
  taskGroups: TaskGroup[],
  projectOnboardings: ProjectOnboarding[],
): ProjectTask[] {
  if (!userId || !p.id || p.status === 'completed') return [];
  const all = mergeTasksForWorkQueueEligibility(p, projectTasks, taskGroups, projectOnboardings);
  const pTasks = all.filter(
    (t) => isEarlyFunnelProjectPhase(p.phase) || t.department !== 'preconstruction',
  );
  return pTasks.filter((t) => t.status !== 'completed' && taskInvolvesUser(t, userId));
}
